import { Modal, Button } from '@maxtropy/components';
import  { FC } from 'react';
import {  deviceAssetTypeEnum} from '../utils';
import { deviceAssetsResponse } from '.';

export interface IInferenceConfig {
  setOpen: (value: boolean) => void;
  energyAssetInfo?: deviceAssetsResponse;
}

const EnergyAssetInfoModal: FC<IInferenceConfig> = props => {
  const { energyAssetInfo, setOpen } = props;
  return (
    <Modal
      open
      onCancel={() => {
        setOpen(false);
      }}
      title={'能源资产信息'}
      footer={[
        <Button key={'cancel'} onClick={() => setOpen(false)}>
          关闭
        </Button>,
      ]}>
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.PVSTATION).length !== 0 && (
            <>
              <h3 style={{ fontWeight: 700 }}>光伏能源资产编号</h3>
              <p>
                {energyAssetInfo
                  ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.PVSTATION)
                  .map(i => i.deviceAssetCode)
                  .join(',')}
              </p>
            </>
          )}

        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.ENERGYSTORAGEARRAY).length !==
          0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>储能能源资产编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.ENERGYSTORAGEARRAY)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}

        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.NETENERGY).length !== 0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>微网能源资产编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.NETENERGY)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.CHARGING).length !== 0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>充电站能源资产编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.CHARGING)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.TOPOLOGY).length !== 0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>能源介质拓扑编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.TOPOLOGY)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.GAS_PREPARATION_STATION).length !==
          0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>气体制备站编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.GAS_PREPARATION_STATION)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.HVAC).length !== 0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>暖通空调编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.HVAC)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
        {energyAssetInfo?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.WIND_POWER).length !== 0 && (
          <>
            <h3 style={{ fontWeight: 700 }}>风电站编号</h3>
            <p>
              {energyAssetInfo
                ?.filter(item => item.deviceAssetType === deviceAssetTypeEnum.WIND_POWER)
                .map(i => i.deviceAssetCode)
                .join(',')}
            </p>
          </>
        )}
    </Modal>
  );
};

export default EnergyAssetInfoModal;
